import { render } from "./Clubs.vue?vue&type=template&id=b3bb8c7e&ts=true"
import script from "./Clubs.vue?vue&type=script&lang=ts"
export * from "./Clubs.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__